export function getClientWidth(): number {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}
